module.exports = __webpack_public_path__ + "media/images/icon__reddit@3x-603aedd8c42df5d4784498f521f56dab.png";